/**
 * @param {Object} fieldState
 * @param {boolean} fieldState.isTouched
 * @param {boolean} fieldState.isSubmitted
 * @param {string} fieldState.error
 * @param {string} fieldState.helperText
 * @param {Object} options
 * @param {boolean} options.skipTouchedCheck
 *
 * @returns {{ error: boolean, helperText: string }}
 */
export function getFieldError(fieldState, options = {}) {
  let error = false;
  let helperText = fieldState?.helperText || '';

  const showError = options.skipTouchedCheck || fieldState?.isTouched || fieldState?.isSubmitted;

  if (!fieldState || !showError) {
    return {
      error,
      helperText,
    };
  }

  if (fieldState.error) {
    error = !!fieldState.error;
    helperText = fieldState.error || '';
  }

  return { error, helperText };
}

export function combineFieldProps(field, renderOptions, options = {}) {
  return {
    ...renderOptions.field,
    ...field,
    ...getFieldError({
      helperText: field?.helperText || null,
      isTouched: renderOptions.fieldState.isTouched,
      error: renderOptions.fieldState.error?.message,
      isSubmitted: renderOptions.formState.submitCount > 0 || renderOptions.formState.isSubmitted,
    }),
    ...options,
  };
}
